// Textos de Desligamentos (27/10/2026), coletados por glob em core/i18n/messages.ts.
export default {
  pt: {
    'dp.deslig.ctx.cargasValor': '{{n}} cargas desde {{desde}}',
    'dp.deslig.ctx.diariaValor': 'Diária {{data}}, {{status}}',
    'dp.deslig.estado.aberto': 'Aberto',
    'dp.deslig.estado.pago': 'Pago',
    'dp.deslig.estado.cancelado': 'Cancelado',
    'dp.deslig.titulo': 'Desligamentos',
    'dp.deslig.novo': 'Novo desligamento',
    'dp.deslig.novoTitulo': 'Novo desligamento',
    'dp.deslig.editarTitulo': 'Dados do desligamento de {{nome}}',
    'dp.deslig.nomeSeFora': 'Nome, só se a matrícula não estiver no Hub',
    'dp.deslig.nomeSeForaAjuda': 'O Hub procura a matrícula no cadastro e no quadro do Protheus.',
    'dp.deslig.prazoAutomatico': 'O prazo de pagamento nasce do último dia trabalhado mais 9 dias, o 10º dia da CLT.',
    'dp.deslig.semInformar': 'Sem informar',
    'dp.deslig.aviso': 'Aviso',
    'dp.deslig.ultimoDia': 'Último dia trabalhado',
    'dp.deslig.pagarAte': 'Pagar até',
    'dp.deslig.emailEnviado': 'E-mail às áreas em',
    'dp.deslig.gestor': 'Gestor',
    'dp.deslig.iniciativa': 'Iniciativa',
    'dp.deslig.tipoRescisao': 'Tipo de rescisão',
    'dp.deslig.tipoAviso': 'Tipo de aviso',
    'dp.deslig.iniciativa.empregado': 'Empregado',
    'dp.deslig.iniciativa.empresa': 'Empresa',
    'dp.deslig.iniciativa.falecimento': 'Falecimento',
    'dp.deslig.iniciativa.pedido': 'Pedido',
    'dp.deslig.tipo_rescisao.pedido_de_demissao': 'Pedido de demissão',
    'dp.deslig.tipo_rescisao.sem_justa_causa': 'Demissão sem justa causa',
    'dp.deslig.tipo_rescisao.com_justa_causa': 'Demissão com justa causa',
    'dp.deslig.tipo_rescisao.termino_de_contrato': 'Término de contrato',
    'dp.deslig.tipo_rescisao.quebra_de_contrato': 'Quebra de contrato',
    'dp.deslig.tipo_rescisao.aposentadoria': 'Aposentadoria',
    'dp.deslig.tipo_rescisao.falecimento': 'Falecimento',
    'dp.deslig.tipo_rescisao.processo_trabalhista': 'Processo trabalhista',
    'dp.deslig.tipo_rescisao.rescisao_complementar': 'Rescisão complementar',
    'dp.deslig.tipo_aviso.trabalhado': 'Trabalhado',
    'dp.deslig.tipo_aviso.indenizado': 'Indenizado',
    'dp.deslig.tipo_aviso.dispensado': 'Dispensado',
    'dp.deslig.tipo_aviso.misto': 'Misto',
    'dp.deslig.valor.liquido': 'Líquido da rescisão',
    'dp.deslig.valor.fgts': 'FGTS',
    'dp.deslig.valor.e_consignado': 'E-consignado',
    'dp.deslig.situacao.aberto': 'Abertos',
    'dp.deslig.situacao.pago': 'Pagos',
    'dp.deslig.situacao.cancelado': 'Cancelados',
    'dp.deslig.situacao.todos': 'Todos',
    'dp.deslig.kpi.abertos': 'Abertos',
    'dp.deslig.kpi.vencidos': 'Pagamento vencido',
    'dp.deslig.kpi.proximos': 'Pagar em {{proximoDias}} dias',
    'dp.deslig.kpi.pagos': 'Pagos',
    'dp.deslig.kpi.cancelados': 'Cancelados',
    'dp.deslig.col.datas': 'Aviso e último dia',
    'dp.deslig.col.pagamento': 'Pagamento',
    'dp.deslig.col.tipo': 'Rescisão',
    'dp.deslig.col.checklist': 'Checklist',
    'dp.deslig.col.item': 'Item',
    'dp.deslig.col.area': 'Área',
    'dp.deslig.avisoEm': 'Aviso em {{data}}',
    'dp.deslig.ultimoDiaEm': 'Último dia {{data}}',
    'dp.deslig.avisoTipo': 'Aviso {{tipo}}',
    'dp.deslig.checklistCurto': '{{feitos}} de {{total}}',
    'dp.deslig.checklistTitulo': 'Checklist das áreas, {{feitos}} de {{total}} respondidos',
    'dp.deslig.abrirCaso': 'Abrir',
    'dp.deslig.responder': 'Responder',
    'dp.deslig.itemArea': 'Área que responde: {{area}}',
    'dp.deslig.item.pendente': 'Pendente',
    'dp.deslig.item.sem_pendencia': 'Sem pendência',
    'dp.deslig.item.descontar': 'Descontar',
    'dp.deslig.item.nao_se_aplica': 'Não se aplica',
    'dp.deslig.valorDesconto': 'Valor a descontar',
    'dp.deslig.contextoTitulo': 'O que o Hub sabe da pessoa',
    'dp.deslig.ctx.conjunto': 'Conjunto',
    'dp.deslig.ctx.semConjunto': 'Sem conjunto',
    'dp.deslig.ctx.gestoes': 'Gestões',
    'dp.deslig.ctx.gestoesValor': '{{pendentes}} pendentes, {{aplicadas}} aplicadas',
    'dp.deslig.ctx.diaria': 'Última diária no Protheus',
    'dp.deslig.ctx.cargas': 'Cargas desde {{desde}}',
    'dp.deslig.ctx.foraDoHub': 'Fora do cadastro do Hub',
    'dp.deslig.email': 'E-mail às áreas',
    'dp.deslig.emailTitulo': 'E-mail às áreas sobre {{nome}}',
    'dp.deslig.limite': 'Data e hora limite para o retorno',
    'dp.deslig.editar': 'Editar dados',
    'dp.deslig.pagar': 'Marcar como pago',
    'dp.deslig.cancelar': 'Cancelar',
    'dp.deslig.reabrir': 'Reabrir',
    'dp.deslig.situacaoTitulo.pago': 'Pagar a rescisão de {{nome}}',
    'dp.deslig.situacaoTitulo.cancelado': 'Cancelar o desligamento de {{nome}}',
    'dp.deslig.situacaoTitulo.aberto': 'Reabrir o desligamento de {{nome}}',
    'dp.deslig.situacaoExplica.pago': 'O caso sai da fila, e o prazo fica concluído.',
    'dp.deslig.situacaoExplica.cancelado': 'Cancelar pede o motivo, que fica registrado.',
    'dp.deslig.situacaoExplica.aberto': 'Reabrir pede a justificativa, que fica registrada.',
    'dp.deslig.enviadoEm': 'E-mail enviado em {{data}}',
    'dp.deslig.enviarHub': 'Enviar pelo Hub',
    'dp.deslig.enviado': 'E-mail enviado a {{n}} áreas.',
    'dp.deslig.todasAreas': 'Enviar a todas as áreas, e não só às que têm item pendente',
    'dp.deslig.vaoReceber': 'Vão receber',
    'dp.deslig.ninguemParaReceber': 'Nenhuma área com endereço para receber.',
    'dp.deslig.copiaPara': 'Cópia e respostas para {{email}}',
    'dp.deslig.semEndereco': 'Sem endereço cadastrado: {{areas}}.',
    'dp.deslig.semEnderecoAjuda': 'Cadastre em Destinatários de alerta.',
    'dp.deslig.casoEncerradoEmail': 'O caso não está aberto, então o e-mail não sai pelo Hub.',
    'dp.deslig.destinatarios': 'Destinatários',
  },
  en: {
    'dp.deslig.ctx.cargasValor': '{{n}} loads since {{desde}}',
    'dp.deslig.ctx.diariaValor': 'Daily record {{data}}, {{status}}',
    'dp.deslig.estado.aberto': 'Open',
    'dp.deslig.estado.pago': 'Paid',
    'dp.deslig.estado.cancelado': 'Canceled',
    'dp.deslig.titulo': 'Terminations',
    'dp.deslig.novo': 'New termination',
    'dp.deslig.novoTitulo': 'New termination',
    'dp.deslig.editarTitulo': 'Termination details of {{nome}}',
    'dp.deslig.nomeSeFora': 'Name, only if the employee ID is not in the Hub',
    'dp.deslig.nomeSeForaAjuda': 'The Hub looks up the employee ID in the records and in the Protheus staff.',
    'dp.deslig.prazoAutomatico': 'The payment deadline comes from the last working day plus 9 days, the 10th day of labor law.',
    'dp.deslig.semInformar': 'Not informed',
    'dp.deslig.aviso': 'Notice',
    'dp.deslig.ultimoDia': 'Last working day',
    'dp.deslig.pagarAte': 'Pay by',
    'dp.deslig.emailEnviado': 'E-mail to areas on',
    'dp.deslig.gestor': 'Manager',
    'dp.deslig.iniciativa': 'Initiative',
    'dp.deslig.tipoRescisao': 'Termination type',
    'dp.deslig.tipoAviso': 'Notice type',
    'dp.deslig.iniciativa.empregado': 'Employee',
    'dp.deslig.iniciativa.empresa': 'Company',
    'dp.deslig.iniciativa.falecimento': 'Death',
    'dp.deslig.iniciativa.pedido': 'Request',
    'dp.deslig.tipo_rescisao.pedido_de_demissao': 'Resignation',
    'dp.deslig.tipo_rescisao.sem_justa_causa': 'Dismissal without cause',
    'dp.deslig.tipo_rescisao.com_justa_causa': 'Dismissal for cause',
    'dp.deslig.tipo_rescisao.termino_de_contrato': 'End of contract',
    'dp.deslig.tipo_rescisao.quebra_de_contrato': 'Breach of contract',
    'dp.deslig.tipo_rescisao.aposentadoria': 'Retirement',
    'dp.deslig.tipo_rescisao.falecimento': 'Death',
    'dp.deslig.tipo_rescisao.processo_trabalhista': 'Labor lawsuit',
    'dp.deslig.tipo_rescisao.rescisao_complementar': 'Supplementary termination',
    'dp.deslig.tipo_aviso.trabalhado': 'Worked',
    'dp.deslig.tipo_aviso.indenizado': 'Paid in lieu',
    'dp.deslig.tipo_aviso.dispensado': 'Waived',
    'dp.deslig.tipo_aviso.misto': 'Mixed',
    'dp.deslig.valor.liquido': 'Net termination pay',
    'dp.deslig.valor.fgts': 'FGTS',
    'dp.deslig.valor.e_consignado': 'Payroll loan',
    'dp.deslig.situacao.aberto': 'Open',
    'dp.deslig.situacao.pago': 'Paid',
    'dp.deslig.situacao.cancelado': 'Canceled',
    'dp.deslig.situacao.todos': 'All',
    'dp.deslig.kpi.abertos': 'Open',
    'dp.deslig.kpi.vencidos': 'Payment overdue',
    'dp.deslig.kpi.proximos': 'Pay within {{proximoDias}} days',
    'dp.deslig.kpi.pagos': 'Paid',
    'dp.deslig.kpi.cancelados': 'Canceled',
    'dp.deslig.col.datas': 'Notice and last day',
    'dp.deslig.col.pagamento': 'Payment',
    'dp.deslig.col.tipo': 'Termination',
    'dp.deslig.col.checklist': 'Checklist',
    'dp.deslig.col.item': 'Item',
    'dp.deslig.col.area': 'Area',
    'dp.deslig.avisoEm': 'Notice on {{data}}',
    'dp.deslig.ultimoDiaEm': 'Last day {{data}}',
    'dp.deslig.avisoTipo': 'Notice {{tipo}}',
    'dp.deslig.checklistCurto': '{{feitos}} of {{total}}',
    'dp.deslig.checklistTitulo': 'Area checklist, {{feitos}} of {{total}} answered',
    'dp.deslig.abrirCaso': 'Open',
    'dp.deslig.responder': 'Answer',
    'dp.deslig.itemArea': 'Responsible area: {{area}}',
    'dp.deslig.item.pendente': 'Pending',
    'dp.deslig.item.sem_pendencia': 'Nothing pending',
    'dp.deslig.item.descontar': 'Deduct',
    'dp.deslig.item.nao_se_aplica': 'Not applicable',
    'dp.deslig.valorDesconto': 'Amount to deduct',
    'dp.deslig.contextoTitulo': 'What the Hub knows about the person',
    'dp.deslig.ctx.conjunto': 'Truck set',
    'dp.deslig.ctx.semConjunto': 'No truck set',
    'dp.deslig.ctx.gestoes': 'Disciplinary actions',
    'dp.deslig.ctx.gestoesValor': '{{pendentes}} pending, {{aplicadas}} applied',
    'dp.deslig.ctx.diaria': 'Last daily record in Protheus',
    'dp.deslig.ctx.cargas': 'Loads since {{desde}}',
    'dp.deslig.ctx.foraDoHub': 'Not in the Hub records',
    'dp.deslig.email': 'E-mail to areas',
    'dp.deslig.emailTitulo': 'E-mail to areas about {{nome}}',
    'dp.deslig.limite': 'Reply deadline, date and time',
    'dp.deslig.editar': 'Edit details',
    'dp.deslig.pagar': 'Mark as paid',
    'dp.deslig.cancelar': 'Cancel',
    'dp.deslig.reabrir': 'Reopen',
    'dp.deslig.situacaoTitulo.pago': 'Pay the termination of {{nome}}',
    'dp.deslig.situacaoTitulo.cancelado': 'Cancel the termination of {{nome}}',
    'dp.deslig.situacaoTitulo.aberto': 'Reopen the termination of {{nome}}',
    'dp.deslig.situacaoExplica.pago': 'The case leaves the queue, and the deadline is done.',
    'dp.deslig.situacaoExplica.cancelado': 'Canceling needs the reason, which is recorded.',
    'dp.deslig.situacaoExplica.aberto': 'Reopening needs a justification, which is recorded.',
    'dp.deslig.enviadoEm': 'E-mail sent on {{data}}',
    'dp.deslig.enviarHub': 'Send from the Hub',
    'dp.deslig.enviado': 'E-mail sent to {{n}} areas.',
    'dp.deslig.todasAreas': 'Send to all areas, not only those with a pending item',
    'dp.deslig.vaoReceber': 'Recipients',
    'dp.deslig.ninguemParaReceber': 'No area with an address to receive it.',
    'dp.deslig.copiaPara': 'Copy and replies to {{email}}',
    'dp.deslig.semEndereco': 'No address registered: {{areas}}.',
    'dp.deslig.semEnderecoAjuda': 'Register it in Alert recipients.',
    'dp.deslig.casoEncerradoEmail': 'The case is not open, so the e-mail does not go out from the Hub.',
    'dp.deslig.destinatarios': 'Recipients',
  },
  es: {
    'dp.deslig.ctx.cargasValor': '{{n}} cargas desde {{desde}}',
    'dp.deslig.ctx.diariaValor': 'Diario {{data}}, {{status}}',
    'dp.deslig.estado.aberto': 'Abierto',
    'dp.deslig.estado.pago': 'Pagado',
    'dp.deslig.estado.cancelado': 'Cancelado',
    'dp.deslig.titulo': 'Desvinculaciones',
    'dp.deslig.novo': 'Nueva desvinculación',
    'dp.deslig.novoTitulo': 'Nueva desvinculación',
    'dp.deslig.editarTitulo': 'Datos de la desvinculación de {{nome}}',
    'dp.deslig.nomeSeFora': 'Nombre, solo si la matrícula no está en el Hub',
    'dp.deslig.nomeSeForaAjuda': 'El Hub busca la matrícula en el registro y en la plantilla del Protheus.',
    'dp.deslig.prazoAutomatico': 'El plazo de pago nace del último día trabajado más 9 días, el 10º día de la ley laboral.',
    'dp.deslig.semInformar': 'Sin informar',
    'dp.deslig.aviso': 'Aviso',
    'dp.deslig.ultimoDia': 'Último día trabajado',
    'dp.deslig.pagarAte': 'Pagar hasta',
    'dp.deslig.emailEnviado': 'Correo a las áreas el',
    'dp.deslig.gestor': 'Gestor',
    'dp.deslig.iniciativa': 'Iniciativa',
    'dp.deslig.tipoRescisao': 'Tipo de desvinculación',
    'dp.deslig.tipoAviso': 'Tipo de aviso',
    'dp.deslig.iniciativa.empregado': 'Empleado',
    'dp.deslig.iniciativa.empresa': 'Empresa',
    'dp.deslig.iniciativa.falecimento': 'Fallecimiento',
    'dp.deslig.iniciativa.pedido': 'Pedido',
    'dp.deslig.tipo_rescisao.pedido_de_demissao': 'Renuncia',
    'dp.deslig.tipo_rescisao.sem_justa_causa': 'Despido sin justa causa',
    'dp.deslig.tipo_rescisao.com_justa_causa': 'Despido con justa causa',
    'dp.deslig.tipo_rescisao.termino_de_contrato': 'Fin de contrato',
    'dp.deslig.tipo_rescisao.quebra_de_contrato': 'Ruptura de contrato',
    'dp.deslig.tipo_rescisao.aposentadoria': 'Jubilación',
    'dp.deslig.tipo_rescisao.falecimento': 'Fallecimiento',
    'dp.deslig.tipo_rescisao.processo_trabalhista': 'Proceso laboral',
    'dp.deslig.tipo_rescisao.rescisao_complementar': 'Desvinculación complementaria',
    'dp.deslig.tipo_aviso.trabalhado': 'Trabajado',
    'dp.deslig.tipo_aviso.indenizado': 'Indemnizado',
    'dp.deslig.tipo_aviso.dispensado': 'Dispensado',
    'dp.deslig.tipo_aviso.misto': 'Mixto',
    'dp.deslig.valor.liquido': 'Líquido de la desvinculación',
    'dp.deslig.valor.fgts': 'FGTS',
    'dp.deslig.valor.e_consignado': 'Préstamo en nómina',
    'dp.deslig.situacao.aberto': 'Abiertos',
    'dp.deslig.situacao.pago': 'Pagados',
    'dp.deslig.situacao.cancelado': 'Cancelados',
    'dp.deslig.situacao.todos': 'Todos',
    'dp.deslig.kpi.abertos': 'Abiertos',
    'dp.deslig.kpi.vencidos': 'Pago vencido',
    'dp.deslig.kpi.proximos': 'Pagar en {{proximoDias}} días',
    'dp.deslig.kpi.pagos': 'Pagados',
    'dp.deslig.kpi.cancelados': 'Cancelados',
    'dp.deslig.col.datas': 'Aviso y último día',
    'dp.deslig.col.pagamento': 'Pago',
    'dp.deslig.col.tipo': 'Desvinculación',
    'dp.deslig.col.checklist': 'Checklist',
    'dp.deslig.col.item': 'Ítem',
    'dp.deslig.col.area': 'Área',
    'dp.deslig.avisoEm': 'Aviso el {{data}}',
    'dp.deslig.ultimoDiaEm': 'Último día {{data}}',
    'dp.deslig.avisoTipo': 'Aviso {{tipo}}',
    'dp.deslig.checklistCurto': '{{feitos}} de {{total}}',
    'dp.deslig.checklistTitulo': 'Checklist de las áreas, {{feitos}} de {{total}} respondidos',
    'dp.deslig.abrirCaso': 'Abrir',
    'dp.deslig.responder': 'Responder',
    'dp.deslig.itemArea': 'Área que responde: {{area}}',
    'dp.deslig.item.pendente': 'Pendiente',
    'dp.deslig.item.sem_pendencia': 'Sin pendiente',
    'dp.deslig.item.descontar': 'Descontar',
    'dp.deslig.item.nao_se_aplica': 'No aplica',
    'dp.deslig.valorDesconto': 'Valor a descontar',
    'dp.deslig.contextoTitulo': 'Lo que el Hub sabe de la persona',
    'dp.deslig.ctx.conjunto': 'Conjunto',
    'dp.deslig.ctx.semConjunto': 'Sin conjunto',
    'dp.deslig.ctx.gestoes': 'Gestiones',
    'dp.deslig.ctx.gestoesValor': '{{pendentes}} pendientes, {{aplicadas}} aplicadas',
    'dp.deslig.ctx.diaria': 'Último diario en el Protheus',
    'dp.deslig.ctx.cargas': 'Cargas desde {{desde}}',
    'dp.deslig.ctx.foraDoHub': 'Fuera del registro del Hub',
    'dp.deslig.email': 'Correo a las áreas',
    'dp.deslig.emailTitulo': 'Correo a las áreas sobre {{nome}}',
    'dp.deslig.limite': 'Fecha y hora límite para la respuesta',
    'dp.deslig.editar': 'Editar datos',
    'dp.deslig.pagar': 'Marcar como pagado',
    'dp.deslig.cancelar': 'Cancelar',
    'dp.deslig.reabrir': 'Reabrir',
    'dp.deslig.situacaoTitulo.pago': 'Pagar la desvinculación de {{nome}}',
    'dp.deslig.situacaoTitulo.cancelado': 'Cancelar la desvinculación de {{nome}}',
    'dp.deslig.situacaoTitulo.aberto': 'Reabrir la desvinculación de {{nome}}',
    'dp.deslig.situacaoExplica.pago': 'El caso sale de la fila, y el plazo queda concluido.',
    'dp.deslig.situacaoExplica.cancelado': 'Cancelar pide el motivo, que queda registrado.',
    'dp.deslig.situacaoExplica.aberto': 'Reabrir pide la justificación, que queda registrada.',
    'dp.deslig.enviadoEm': 'Correo enviado el {{data}}',
    'dp.deslig.enviarHub': 'Enviar por el Hub',
    'dp.deslig.enviado': 'Correo enviado a {{n}} áreas.',
    'dp.deslig.todasAreas': 'Enviar a todas las áreas, y no solo a las que tienen ítem pendiente',
    'dp.deslig.vaoReceber': 'Van a recibir',
    'dp.deslig.ninguemParaReceber': 'Ninguna área con dirección para recibir.',
    'dp.deslig.copiaPara': 'Copia y respuestas para {{email}}',
    'dp.deslig.semEndereco': 'Sin dirección registrada: {{areas}}.',
    'dp.deslig.semEnderecoAjuda': 'Regístrela en Destinatarios de alerta.',
    'dp.deslig.casoEncerradoEmail': 'El caso no está abierto, así que el correo no sale por el Hub.',
    'dp.deslig.destinatarios': 'Destinatarios',
  },
}
